export const camelCaseToFlat = (c: string) =>
  ((c = c.replace(/[A-Z]/g, " $&")), c[0] + c.slice(1)).toLowerCase();
